<div class="container">
  <header [ngStyle]="headerStyle">
    <icn-calendar-header
      *ngIf="showCalendarHeader"
      [activeView]="activeView"
      [title]="currentView.title()"
      [currentDate]="currentView.currentDate"
      [currentChannel]="currentChannel"
      [isGridDisplay]="viewOption === 'grid'"
      [currentShow]="getCurrentShow()"
      [nextShows]="getNextPrerollShows()"
      [lockNow]="lockNow"
      (now)="now()"
      [clinetId]="clientId"
      (prev)="prev()"
      (next)="next()"
      (setViewTypeAndTime)="setViewTypeAndTime($event.viewType, $event.time)"
      (setCurrentDate)="handleCurrentDateChanged($event)"
      (viewOptionChange)="setViewOption($event)"
      (showToSkipToChanged)="updateShowToSkipTo($event.show)"
    >
      <div
        class="permission-overlay"
        *ngIf="
          currentUser &&
          currentChannel &&
          !currentUser.hasEditSchedulePermission(currentChannel)
        "
        title="You don't have edit schedule permission"
      ></div>
    </icn-calendar-header>
    <evrideo-edit-block-header
      *ngIf="editBlockVM"
      [vm]="editBlockVM"
    ></evrideo-edit-block-header>
  </header>

  <icn-calendar-grid
    *ngIf="viewOption === 'grid'"
    [currentView]="currentView"
    [(refreshOnNow)]="refreshOnNow"
    [futurePreviewViewModel]="futurePreviewViewModel"
    (currentDateChange)="onCurrentDateChange($event)"
    (dragHoverTimeout)="onDragHoverTimeout($event)"
    (zoomIn)="onZoomIn($event)"
    (zoomOut)="onZoomOut($event)"
  >
    <div
      class="permission-overlay"
      *ngIf="
        currentUser &&
        currentChannel &&
        !currentUser.hasEditSchedulePermission(currentChannel)
      "
      title="You don't have edit schedule permission"
    ></div>
  </icn-calendar-grid>

  <icn-calendar-list
    *ngIf="viewOption === 'list'"
    [currentView]="currentView"
    [futurePreviewViewModel]="futurePreviewViewModel"
    (currentDateChange)="onCurrentDateChange($event)"
    [(refreshOnNow)]="refreshOnNow"
    [fromSecEventsPopup]="fromSecEventsPopup"
    [currentTime]="currentTime"
    [showCurrentTimeIndicator]="showCurrentTimeIndicator"
    [ngStyle]="calendarListStyle"
    [isBlock]="isBlockEditor"
  >
    <div
      class="permission-overlay"
      *ngIf="
        currentUser &&
        currentChannel &&
        !editBlockVM &&
        !currentUser.hasEditSchedulePermission(currentChannel)
      "
      title="You don't have edit schedule permission"
    ></div>
  </icn-calendar-list>
  <evrideo-future-preview
    *ngIf="futurePreviewViewModel"
    [vm]="futurePreviewViewModel"
    [hidden]="!futurePreviewViewModel.visible"
  ></evrideo-future-preview>
  <ngx-smart-modal
    #replaceShowModal
    identifier="replaceShowModal"
    [@.disabled]="true"
  >
    <evrideo-replace-show-modal></evrideo-replace-show-modal>
  </ngx-smart-modal>

  <ngx-smart-modal
    #renameShowModal
    identifier="renameShowModal"
    [@.disabled]="true"
  >
    <icn-rename-show-modal></icn-rename-show-modal>
  </ngx-smart-modal>

  <ngx-smart-modal
    #chooseSegment
    identifier="chooseSegmentModal"
    [@.disabled]="true"
    [customClass]="'nsm-centered'"
  >
    <evrideo-choose-segment></evrideo-choose-segment>
  </ngx-smart-modal>

  <ngx-smart-modal
    #loopFillShowsPopupModal
    identifier="loopFillShowsPopupModal"
    [@.disabled]="true"
    [customClass]="'nsm-centered'"
  >
    <evrideo-loop-fill-shows></evrideo-loop-fill-shows>
  </ngx-smart-modal>
</div>
